import * as config from "../../assets/config.json";

export class Constants {
  public static get ENTORNO(): string {
    return "LC";
  }
  public static get ROOT_URL(): any {
    let urlAPI: any;

    if (sessionStorage.getItem("urlAPI") === null) {
      var request = new XMLHttpRequest();
      request.open("GET", "./assets/config.json", false);
      request.send(null);
      if (request.status === 200) {
        urlAPI = JSON.parse(request.responseText);
        sessionStorage.setItem("urlAPI", request.responseText);
      }
    } else {
      urlAPI = JSON.parse(sessionStorage.getItem("urlAPI"));
    }

    return urlAPI.url;
    //alert("old");
    /*let url = "";

    switch (this.ENTORNO) {
      case "DV":
        url = "http://18.210.107.20/logisticaapi";
        break;
      case "QA":
        url = "http://18.210.107.20/cncaldas_webapi_qa";
        break;
      case "PR":
        url = "http://18.210.107.20/cncaldas_webapi";
        break;
      case "LC":
        url = "http://localhost/APICOREVENTAS3";
        break;
    }*/
  }

  public static get ROOT_AMBIENTE_VERSION_WEB(): any {
    let ambienteVersionWeb: any;
    if (sessionStorage.getItem("urlAPI") === null) {
      var request = new XMLHttpRequest();
      request.open("GET", "./assets/config.json", false);
      request.send(null);
      if (request.status === 200) {
        ambienteVersionWeb = JSON.parse(request.responseText);
        sessionStorage.setItem("urlAPI", request.responseText);
      }
    } else {
      ambienteVersionWeb = JSON.parse(sessionStorage.getItem("urlAPI"));
    }
    return ambienteVersionWeb;
  }

  public static get BASE_URL(): string {
    const url = this.ROOT_URL + "/api/";
    //console.log(this.ROOT_URL);
    //alert(this.ROOT_URL);
    return url;
  }
  public static get BASE_URL_DOS(): string {
    const url = this.ROOT_URL + "/vAPIa001/";
    return url;
  }
  public static get URL_SINC(): string {
    return "http://18.210.107.20/logisticademo/vAP100/SyncSubida/vEP100/tp/1";
  }
  public static get URL_LOGIN(): string {
    return "Auth/token";
  }
  public static get URL_REFRESH(): string {
    return "renew";
  }
  public static get URL_SIGNALR(): string {
    return "chathub";
  }
  public static get URL_GRAFICAS_INICIO(): string {
    return "Auth/token";
  }
  public static get URL_MENU(): string {
    return "menu";
  }
  public static get URL_FORMULARIO(): string {
    return "formulario";
  }
  /*public static get URL_USUARIO(): string {
    return 'usuario';
  }*/
  public static get URL_REPORTE(): string {
    return "Reporte";
  }
  public static get URL_TRANSPORTADOR(): string {
    return "Transportador";
  }
  public static get URL_SERVICIO(): string {
    return "Servicio";
  }
  public static get URL_DEPARTAMENTO(): string {
    return "Departamento";
  }
  public static get URL_CIUDAD(): string {
    return "Ciudad";
  }
  public static get URL_TIPO_USUARIO(): string {
    return "TipoUsuario";
  }
  public static get URL_DIRECCION(): string {
    return "Direccion";
  }
  public static get URL_USUARIO(): string {
    return "UsuarioApp";
  }
  public static get URL_BLOQUE(): string {
    return "Bloque";
  }
  public static get URL_PERFIL_USUARIO(): string {
    return "PerfilUsuarioWeb";
  }
  public static get URL_MENU_SUBMENU(): string {
    return "MenuSubMenuWeb";
  }
  public static get URL_ENCUESTA(): string {
    return "Encuesta";
  }
  public static get URL_PREGUNTA(): string {
    return "Pregunta";
  }
  public static get URL_ENCUESTA_BLOQUE(): string {
    return "EncuestaBloque";
  }
  public static get URL_BLOQUE_PREGUNTA(): string {
    return "BloquePregunta";
  }
  public static get URL_TIPO_DOCUMENTO(): string {
    return "TipoDocumento";
  }
  public static get URL_PERSONA(): string {
    return "persona";
  }
  public static get URL_ARCHIVO(): string {
    return "Archivo";
  }
  public static get URL_AGENCIA(): string {
    return "Agencia";
  }
  public static get URL_ENTREGAS(): string {
    return "Entrega";
  }
  public static get URL_IMAGEN(): string {
    return "Imagen";
  }
  public static get URL_LOGWS(): string {
    return "LogWS";
  }
  public static get URL_TIPO_NOVEDAD(): string {
    return "TipoNovedad";
  }
  public static get URL_TIPO_MOTIVO(): string {
    return "TipoMotivo";
  }
  public static get URL_MOTIVO(): string {
    return "Motivo";
  }
  public static get URL_TIPO_MOTIVO_CLAS(): string {
    return "TipoMotivoClas";
  }
  public static get URL_PERSONA_VEHICULO(): string {
    return "PersonaVehiculo";
  }
  public static get URL_VEHICULO(): string {
    return "Vehiculo";
  }
  public static get URL_TIPO_PERSONA_VEHICULO(): string {
    return "TipoPersonaVehiculo";
  }
  public static get URL_GRAFICA(): string {
    return "Grafica";
  }
  public static get URL_TIPO_RUTERO(): string {
    return "TipoRutero";
  }
  public static get URL_TIPO_FRECUENCIA(): string {
    return "TipoFrecuencia";
  }
  public static get URL_RUTERO_DIA_SEMANA(): string {
    return "RuteroDiaSemana";
  }
  public static get URL_RUTERO(): string {
    return "Rutero";
  }
  public static get URL_SUCURSAL(): string {
    return "Sucursal";
  }
  public static get URL_JERARQUIA(): string {
    return "Jerarquia";
  }
  public static get URL_GESTION_VENDEDOR(): string {
    return "gestionvendedor";
  }
  public static get URL_GESTION_VENDEDOR_CARTERA(): string {
    return "gestionvendedorcartera";
  }
  public static get URL_GESTION_B2C(): string {
    return "gestionb2c";
  }
  public static get URL_INFORME_NOVEDADES_VENDEDOR(): string {
    return "informenovedadesvendedor";
  }
  public static get URL_RECORRIDO_VENDEDOR(): string {
    return "informerecorrido";
  }
  public static get URL_INFORME_VENTAS_DETALLE(): string {
    return "informeventasdetalle";
  }
  public static get URL_INFORME_VENTAS_PRODUCTO(): string {
    return "informeventasproducto";
  }
  public static get URL_INFORME_VENTAS_MARCA_GRUPO_LINEA(): string {
    return "informeventasgrupomarcalinea";
  }
  public static get URL_INFORME_VENTAS_MARCA_GRUPO_LINEA_DETALLE(): string {
    return "informeventasgrupomarcalinea";
  }
  public static get URL_INFORME_PRODUCTOS(): string {
    return "informeproductos";
  }
  public static get URL_INFORME_CLIENTES_NUEVOS(): string {
    return "clientesnuevos";
  }
  public static get URL_INTEGRACION_CLIENTE(): string {
    return "IntegracionClientes";
  }
  public static get URL_INTEGRACION_VENDEDOR(): string {
    return "IntegracionVendedores";
  }
  public static get URL_INTEGRACION_PRODUCTO(): string {
    //return 'IntegracionProductos';
    return "integracionproductosmolinos";
  }
  public static get URL_INTEGRACION_INVENTARIO(): string {
    //return 'IntegracionProductos';
    return "IntegracionInventario";
  }
  public static get URL_INTEGRACION_AGOTADOS(): string {
    return "IntegracionAgotados";
  }
  public static get URL_INTEGRACION_CARTERA(): string {
    return "integracioncarteramolinos";
  }
  public static get URL_INTEGRACION_PRECIOS(): string {
    return "IntegracionPrecios";
  }
  public static get URL_INTEGRACION_LISTA_PRECIOS(): string {
    return "IntegracionListaPrecio";
  }
  public static get URL_GENERO(): string {
    return "genero";
  }
  public static get URL_EMPRESA_VENTAS(): string {
    return "empresaventas";
  }
  public static get URL_SUCURSAL_VENTAS(): string {
    return "sucursalventas";
  }
  public static get URL_PRODUCTO(): string {
    return "productos";
  }
  public static get URL_TIPO_TARIFA(): string {
    return "tipotarifa";
  }
  public static get URL_VENTA_TARIFA(): string {
    return "ventaTarifa";
  }
  public static get URL_PRECIO(): string {
    return "precio";
  }
  public static get URL_PRODUCTO_GRUPO(): string {
    return "productogrupo";
  }
  public static get URL_PRODUCTO_MARCA(): string {
    return "productomarca";
  }
  public static get URL_PRODUCTO_LINEA(): string {
    return "productolinea";
  }
  public static get URL_PICKING(): string {
    return "picking";
  }
  public static get URL_PICKING_ASIGNACION(): string {
    return "pickingAsignacion";
  }
  public static get URL_PRODUCTO_UNIDAD_MEDIDA(): string {
    return "productounidadmedida";
  }
  public static get URL_IMAGEN_PRODUCTO(): string {
    return "ImagenProducto";
  }
  public static get URL_DASHBOARD(): string {
    return "dashboard";
  }
  public static get URL_ARCHIVO_PEDIDOS(): string {
    return "pedido";
  }
  public static get URL_ENCUESTA_FIJAS(): string {
    return "EncuestaFijas";
  }
  public static get URL_PREGUNTA_FIJAS(): string {
    return "PreguntaFijas";
  }
  public static get URL_BLOQUE_FIJAS(): string {
    return "BloqueFijas";
  }
  public static get URL_ENCUESTA_BLOQUE_FIJAS(): string {
    return "EncuestaBloqueFijas";
  }
  public static get URL_BLOQUE_PREGUNTA_FIJAS(): string {
    return "BloquePreguntaFijas";
  }
  public static get URL_CANAL(): string {
    return "canal";
  }
  public static get URL_SUBCANAL(): string {
    return "subCanal";
  }
  public static get URL_EMPRESA_SUCURSAL(): string {
    return "empresasucursal";
  }
  public static get URL_TIPO_PRESUPUESTO(): string {
    return "tipopresupuesto";
  }
  public static get URL_PRESUPUESTO(): string {
    return "presupuesto";
  }
  public static get URL_CORREO_DISTRIBUIDORA(): string {
    return "emaildistribuidora";
  }
  public static get URL_LISTA_PRECIOS(): string {
    return "listaprecio";
  }
  public static get URL_LISTA_PRECIOS_SUCURSAL(): string {
    return "listapreciosucursal";
  }
  public static get URL_LISTA_PRECIOS_PRODUCTO(): string {
    return "listaprecioproducto";
  }
  public static get URL_LISTA_PRECIOS_PRODUCTO_TARIFA(): string {
    return "listaprecioproductotarifa";
  }
  public static get URL_AUTORIZACION_PEDIDOS(): string {
    return "AutorizacionPedidos";
  }
  public static get URL_TIPO_AUTORIZACION(): string {
    return "tipoautorizacion";
  }
  public static get URL_CLIENTE(): string {
    return "cliente";
  }
  public static get URL_TIPO_CONDICION_PAGO(): string {
    return "tipocondicionpago";
  }
  public static get URL_PEDIDO_WEB(): string {
    return "pedidoweb";
  }
  public static get URL_INTEGRACION_ETL(): string {
    return "IntegracionUniversalEtl";
  }
  //****** Constantes Modulo Cargues */
  public static get URL_TIPO_VEHICULO(): string {
    return "EntrTpoVehiculo";
  }
  //****** Constantes Empresa Transporte */
   public static get URL_EMPRESA_TRANSPORTE(): string {
    return "EntrEmpresaTransporte";
  }
  //****** Constantes Picking Cargue Nuevo */
  public static get URL_PICKING_CARGUE(): string {
    return "PickingCargue";
  }
  //****** Constantes Vehiculo */
  public static get URL_VEHICULO_TRANSPORTE(): string {
    return "EntrVehiculo";
  }
  //****** Constantes Conductor */
  public static get URL_CONDUCTOR_TRANSPORTE(): string {
    return "EntrConductor";
  }
}
